// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-up-double-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.46484 11.0373L12.0004 7.50177L15.5359 11.0373M8.46484 16.4982L12.0004 12.9627L15.5359 16.4982","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronUpDoubleSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-up-double-s',
    ref,
    icon: element,
  },
));

ChevronUpDoubleSIcon.displayName = 'ChevronUpDoubleSIcon';

export default ChevronUpDoubleSIcon;
